import { getCurrentYear } from './getCurrentYear';
import { mergeArraysAndSortByYear } from './mergeArraysAndSortByYear';

export const getMinYearCO2Interventions = (exanteProject, interventions, newInterventions) => {
  const allInterventions = mergeArraysAndSortByYear(interventions, newInterventions);

  if(!allInterventions || !allInterventions.length) {
    return exanteProject.length
      ? exanteProject.at(-1).initial_year
      : getCurrentYear();
  } else {

    const expostYears = allInterventions.map(i => i.year);

    return Math.max(...expostYears);
  }
};